export default {
  host:
    process.env.NODE_ENV === "development" ? "/api" : "//ciyun.5118.com/api",
  waterMaskImageUrl:
    "//ciyun.5118.com/381357a7-92e6-4bec-a807-b4868428e3f3.png?v=2020021321",
  clickSkip2SuCaiUrl: "https://so.5118.com/all/", //跳转到素材搜索
  clickSkip2ChangWeiCiUrl: "https://ci.5118.com/" //长尾词链接
};
